module.exports = __webpack_public_path__ + "img/breadcrumb-arrow-icon.d7c3b0c2.svg";